I18n.translations.CS = {
  "loading": "načítám...",
  "watched": "Shlédnuté filmy",
  "favourites": "Oblíbené filmy",
  "recommended": "Doporučené filmy",
  "myaccount": "Můj účet",
  "signin_signup": "Přihlásit se",
  "back": "Zpět",
  "yes": "Ano",
  "no": "Ne",
  "ok": "OK",
  'support': 'Support',

  "personal_info": "Osobní informace",
  "paired_devices": "Zpárovaná zařízení",
  "settings": "Nastavení",
  "billing_info": "Platební informace",
  "signout": "Odhlásit",

  "sign-headline": "Přinášíme Vám video zážitek.",
  "label-email": "Email",
  "label-password": "Heslo",
  "label-password-confirm": "Heslo znovu",
  "label-or": "nebo",
  "label-signin": "Přihlásit",
  "label-signup": "Zaregistrovat",
  "label-goback": "Zpět",

  "signin_successful": "Přihlášení bylo úspěšné.",
  "invalid_username": "Neplatné uživatelské jméno.",
  "invalid_pwd_not_same": "Hesla se neshodují",
  "invalid_pwd_tooshort": "Heslo je příliš krátké.",

  "home":"Domů",
  "movies":"Filmy",
  "tv_shows":"Seriály",
  "livetv":"Živě",
  "dots":"...",

  "movie":"Film",
  "tv_show":"Seriál",

  "min": " min",

  "season": "série",
  "seasons": "série",
  "director": "Režie:",
  "cast": "Hrají:",

  "play": "spustit",
  "last_episode": "poslední episoda",
  "trailer": "trailer",
  "cast": "hrají",
  "plot": "popis",

  "rw_x": "x",
  "ff_x": "x",

  "paused": "pozastaveno",
  
  "usb_error": "USB nenalezeno",
  "usb_error_msg": "Data z USB disku nejsou nyní dostupná. Aplikace bude ukončena.",

  "player_error": "Chyba s přehráváním",

  "empty_category":"Ještě není naimplementováno.", // Kategorie je nyní prázdná.

  "forbidden": "Přehrávání je zakázáno.",
  "playback_not_available": "Přehrávaní není dostupné v tomto demu.",
  "sign_in_please":"Musíte se nejprve přihlásit.",

  "dialog_exit_title": "Ukončit aplikaci",
  "dialog_exit_content": "Opravdu chcete ukončit aplikaci?",

  "connection_down": "Problém s připojením na internet.",
  "connection_up": "Internetové připojení je obnoveno.",

  "breadcrumb_scene_home": "Domů",
  "breadcrumb_scene_myaccount": "Můj účet",

  "breadcrumb_editors_choice": "Výběr",
  "breadcrumb_most_popular": "Populární",
  "breadcrumb_related": "Podobné",

  "not_yet_implemented": "Ještě není naimplementováno.",
  "not_yet_implemented_detail": "Detail ještě není naimplementován.",
  "not_yet_implemented_search": "Vyhledávání ještě není naimplementováno.",

  "loginOk": "Přihlášení proběhlo v pořádku",

  "token_expired":"Přihlášení vypršelo, přihlašte se znovu prosím."
};


//////////////////
// WEBPACK FOOTER
// ./js/i18n/cs.js
// module id = 40
// module chunks = 0